var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('base-button', {
    on: {
      "click": function click($event) {
        _vm.isVisible = !_vm.isVisible;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("icons/security/safedeal-gradient.svg"),
      "alt": ""
    }
  })]), _c('base-dialog', {
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c('dialog-template', [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.service.title'))
    },
    slot: "title"
  }), _c('div', {
    class: _vm.$style.content,
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.service.security'))
    }
  }), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.service.information'))
    }
  }), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.service.notification'))
    }
  }), _vm.confirmationCountDays ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('safe.deal.service.confirmation', {
        days: _vm.pluralizedDays
      }))
    }
  }) : _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.service.close'))
    }
  })]), _c('div', {
    directives: [{
      name: "grow",
      rawName: "v-grow"
    }],
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('simple-button', {
    on: {
      "click": function click($event) {
        _vm.isVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dialog.button.clear')) + " ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }